import SettingsModal from '@cimpress-technology/react-platform-settings';
import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { actions as configActions, selectors as configSelectors } from '../../reducers/configurations';

import { auth } from '../../utils/auth';
import AppSettingsConfig from './AppSettingsConfig';
import { withTranslation } from 'react-i18next';
import { SupportedLanguages } from '../../constants/appConstants';

export function LayoutSettings({
  userConfigSettings,
  updateUserConfig,
  fetchUserConfig,
  isFetchingUserConfigurations,
  i18n,
  t
}) {
  const [enableShippingCosts, setEnableShippingCosts] = useState(userConfigSettings.enableShippingCosts);
  const [showTerminated, setShowTerminated] = useState(userConfigSettings.showTerminated);

  useEffect(() => setEnableShippingCosts(enableShippingCosts), [userConfigSettings.enableShippingCosts]);
  useEffect(() => setShowTerminated(showTerminated), [userConfigSettings.showTerminated]);
  useEffect(() => {
    fetchUserConfig();
  }, []);

  const onOpen = useCallback(() => {
    // Reset to current user config settings
    setEnableShippingCosts(userConfigSettings.enableShippingCosts);
    setShowTerminated(userConfigSettings.showTerminated);
  });

  const onSave = useCallback(async () => {
    const updatedSettings = {
      enableShippingCosts,
      showTerminated
    };

    await updateUserConfig(updatedSettings);
    await fetchUserConfig();
  });

  const toggleTerminated = useCallback(() => {
    setShowTerminated(!showTerminated);
  });

  const toggleEnableShippingCosts = useCallback(() => {
    setEnableShippingCosts(!enableShippingCosts);
  });

  const appSettingsContent = (
    <AppSettingsConfig
      enableShippingCosts={enableShippingCosts}
      showTerminated={showTerminated}
      toggleTerminated={toggleTerminated}
      toggleEnableShippingCosts={toggleEnableShippingCosts}
      isFetchingUserConfigurations={isFetchingUserConfigurations}
    />
  );

  return (
    <SettingsModal
      appSettingsContent={appSettingsContent}
      authToken={auth.getAccessToken()}
      lang={i18n.language}
      supportedLanguages={SupportedLanguages}
      onOpen={onOpen}
      onSave={onSave}
    />
  );
}

const mapStateToProps = state => {
  return {
    userConfigSettings: configSelectors.getUserConfigSettings(state),
    isFetchingUserConfigurations: configSelectors.getIsFetchingUserConfigurations(state)
  };
};

const mapDispatchToProps = {
  updateUserConfig: configActions.updateUserConfig,
  fetchUserConfig: configActions.fetchUserConfig
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(LayoutSettings));
